import styled from "styled-components";
import { PagesWrapper } from "../../../../../components/PageSelector/styled";

export const PageSelectorWrapper = styled.div`
  ${PagesWrapper} {
    margin-top: 0;
    margin-bottom: 16px;
    width: max-content;
  }
`;
